// extracted by mini-css-extract-plugin
export var actionButton = "_px-0";
export var actionMenuContainer = "_px-i";
export var bubble = "_px-2";
export var bubbleActionMenu = "_px-j";
export var bubbleContext = "_px-6";
export var bubbleItems = "_px-7";
export var customer = "_px-3";
export var divider = "_px-8";
export var fileList = "_px-9";
export var hiddenComment = "_px-o";
export var infoAbove = "_px-a";
export var internal = "_px-4";
export var lightActionButton = "_px-1";
export var link = "_px-b";
export var merchant = "_px-5";
export var message = "_px-c";
export var profilePicture = "_px-e";
export var quillToolbarContainer = "_px-f";
export var senderDate = "_px-g";
export var senderDateCustomer = "_px-h";
export var senderName = "_px-d";
export var time = "_px-k";
export var uploadedImage = "_px-l";
export var username = "_px-m";
export var xsmall = "_px-n";